import {Dialog} from '~/src/design-system'
import styled from 'styled-components'
import React from 'react'
import {Button as DSButton} from '~/src/design-system/Primitives'
import {useAppDispatch} from '~/src/store/store-hooks'

const HeaderText = styled('div')`
  font-size: 28px;
  font-weight: 700;
  padding-bottom: 30px;
  margin-bottom: 40px;
  width: 100%;
  border-bottom: 1px solid grey;
`

const Button = styled(DSButton)`
  margin-top: 100px;
  font-weight: normal;
`

const Container = styled('div')`
  background-color: #fafafa;
  border-bottom: 1px solid #ebebeb;
  font-size: 18px;
  font-weight: 400;
  display: flex;
  align-items: center;
`

const SubContainer = styled('div')`
  background-color: #e5e5e5;
  border-bottom: 1px solid black;
  font-size: 18px;
  font-weight: 700;
  display: flex;
  align-items: center;
`

const OrderPlaced = styled('div')`
  display: flex;
  justify-content: center;
  text-align: center;
  font-size: 28px;
  font-weight: 600;
  margin-top: 50px;
`

interface IProps {
  onModalClose(): void
  isModalOpen: boolean
}

export default function ExpiredPasswordDialog({onModalClose, isModalOpen}: IProps): JSX.Element {
  const dispatch = useAppDispatch()

  return (
    <Dialog
      fullWidth
      open={isModalOpen}
      onClose={onModalClose}
      PaperProps={{sx: {maxWidth: 900, height: 500}}}>
      <>
        <Container>
          <div style={{marginLeft: 40, padding: 20}}>Your Password Is Expired</div>
        </Container>
        <div
          style={{
            backgroundColor: '#FFFFFF',
            marginTop: '100px',
          }}>
          <OrderPlaced>
            Your password has expired and need to contact your administrator for assistance.
          </OrderPlaced>
          <div
            style={{margin: '40px', marginTop: '48px', display: 'flex', justifyContent: 'center'}}>
            <Button onClick={onModalClose} variant="primary" type="button">
              Back To Sign In
            </Button>
          </div>
        </div>
      </>
    </Dialog>
  )
}
